module.exports = __webpack_public_path__ + "static/img/new-001.d405c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-001.png
// module id = GxA2
// module chunks = 1